let apiServices = {
  //file_upload apis
  uploadFile: "/file/upload",
  bankInfo: "/employee/document/account",
  importEmployee: "/employee/upload",
  currentUserInfo: "/user/info",

  // //User Login
  // userSignin: "/user/auth/login",
  // userGoogleSignin: "auth/google",
  // userFacebookSignin: "auth/facebook",
  // getUserDetails: "get-user-details-by-token",
  // userInfo: "/user/info",
  // userRegistration: "/client",
  // getCountryList: "/country",
  verifyOtp: "/user/verify",
  resetPassword: "/user/reset-forget-password",
  forgetPassword: "/user/forget-password",
  changePassword: "/user/reset-password",
  currentUserRolePermissions: "/role-permissions/current-user",
  currentUserSession: "/user/verify/session",

  // //RolesPermissionByRole
  getRolePermissionsByRoles: "role-user-permission",
  getRoleMasters: "/role",
  addAccessRole: "/role",

  // //warehouse,
  // addRelationType: "relation-type",

  // // staff / employees
  getEmployeesMaster: "/staff",
  user: "/user",
  deleteEmployee: "/user",
  employees: "/user",
  branch: "/branch",
  userById: "/employee/details",

  addEmployeeMaster: "/employee",
  employeeRegistration: "/employee",
  employeeRegistrationById: "/employee",
  employeeExport: "/employee/export/excel",
  getReligion: "/religion",
  getCountry: "/country",
  jobTitle: "/job-title",
  jobGrade: "/job-grade",
  getState: "/state",
  getNationality: "/nationality",
  getDepartment: "/department",
  departmentExport: "/export/excel/Department",
  designationExport: "/export/excel/Designation",
  bankExport: "/export/excel/Bank",
  religionExport: "/export/excel/Religion",
  jobTitleExport: "/export/excel/JobTitle",
  jobGradeExport: "/export/excel/JobGrade",
  securityGroupExport: "/export/excel/SecurityGroup",
  rolesExport: "/export/excel/Role",
  branchesExport: "/export/excel/Branch",
  auditTrailExport: "/audit-trial/export",
  bulkStatusUpdate: "/custom-apis/bulk-status-update",
  employeeInvitation: "/employee/invitation",

  getDesignation: "/designation",
  getEmployees: "/employees",
  getContactTypeMaster: "/contract-type",
  getProbationPeriodMaster: "/probation-period",
  getEmployementTypeMaster: "/employee-type",
  getIqamaProfession: "/iqamaprofession",
  getBankMaster: "/bank",
  getVisaTypeMaster: "/visa-type",
  getInsuranceClass: "/insuranceclass",
  getRelation: "/relation",
  getEmployeeInfoMaster: "/employee/employee-info",
  getEmployeeDepartmentById: "/department/:publicId",
  iqamaDocMaster: "/employee/document/iqama",
  addDocumentMaster: "/file/upload",
  stats: "/stats/status/User",
  getImportStatus: "/queue/status",
  newEmployeeCount: "/new-employee-count",
  designationStats: "/stats/status/Designation",
  departmentStats: "/stats/status/Department",
  securityGroupStats: "/stats/status/SecurityGroup",
  roleStats: "/stats/status/Role",
  branchStats: "/stats/status/Branch",
  getEmployeesInfo: "/staff",
  staff: "/staff",
  getEmployeesRegistration: "/employee",
  auditTrail: "/audit-trial",
  securityGroup: "/security-group",
  permissionByAuth: "/permission/group-permissions-by-auth-provider",
  securityGroupPermissions: "/security-group-permissions",

  getEmployeePersonalInfo: "/employee",

  getEmployeeEmployementInfo: "/employee/employee-info",
  getEmployeeSalaryDetails: "/employee/document/salary",
  getEmployeeIqamaDetails: "/employee/document/iqama",
  getEmployeeAccountDetails: "/employee/document/account",
  getEmployeeHealthInsuranceDetails: "/employee/document/insurance",
  getEmployeePassportDetails: "/employee/document/passport",
  getEmployeeVisaDetails: "/employee/document/visa",
  getEmployeeContractDetails: "/employee/document/contract",
  getEmployeeDrivingLicenseDetails: "/employee/document/license",
  getEmployeeSubscriptionDetails: "/employee/document/subscription",
  getDependentsInfo: "/employee/dependents-info",
  dependentsInfo: "/employee/document/dependents-info",
  healthCardInfo: "/employee/document/health/card",

  iqamaInfo: "/employee/document/iqama",
  employmentInfo: "/employee/employee-info",
  salaryDetails: "/employee/document/salary",

  // updateEmployeeMaster: "/staff",
  // deleteEmployeeMaster: "/staff",

  // //department
  // getDepartmentMasters: "/department",
  addDepartmentMaster: "/department",
  // updateDepartmentMaster: "/department",
  // deleteDepartmentMaster: "/department",
  // getByDepartmentById: "/department",
  // //designation apis
  getDesignationMasters: "/designation",
  addDesignationMaster: "/designation",
  // updateDesignationMaster: "/designation",
  // deleteDesignationMaster: "/designation",
  // getDesignationById: "/designation",

  // // contact
  // getContacts: "/contact",
  // importContacts: "/contact/upload",
  // addContacts: "/contact",
  // updateContact: "/contact",
  // getContactsById: "/contact",

  // // Campaign EndPoints
  // getCampaigns: "/campaign",
  // addCampaign: "/campaign",
  // updateCampaign: "/campaign",
  // deleteCampaign: "/campaign",

  // // Campaign Contacts EndPoints
  // addCampaignContact: "/campaign/contact",
  // deleteCampaignContact: "/campaign/contact",
  // getCampaignContacts: "/campaign/contact",
  // getNonCampaignContacts: "/campaign/contact/non-campaign",
  // importCampaignContacts: "/campaign/contact/upload",

  // // company
  // getCompany: "/company",
  // addCompany: "/company",

  // // country
  // getCountry: "/country",
  // getState: "/state",

  // // branch
  // getBranch: "/client/branches",
  // addBranch: "/client/branches",

  // //Template
  // emailTemplate: "/template",

  // Roles

  addAccessRole: "/role",

  // awn
  userSignin: "/user/auth/login",
  //ums
  authUmsProvider: "/user/auth/provider",
  groupPermissionsByAuthProvider:
    "/permission/group-permissions-by-auth-provider",
  getRolePermisson: "/role-permissions",

  // Analytical Dashboard
  analyticsBaseRoute: "/ums/stats",
  getEmpMonthlyData: "/new/inactive/permonth",
  getIqamaStatusData: "/iqama/count",
  getEmpDeptStatsData: "/departments/count",
  getEmpDesgStatsData: "/designation/count",
};

export default apiServices;
